// extracted by mini-css-extract-plugin
export default {"root":"OverlayKYCWrapper_root__TW94H","overlay":"OverlayKYCWrapper_overlay__f0j6C"};